import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Flex, Text } from '@chakra-ui/react'
import { ProductCategory } from '@leid/api-products'
import { useRouter } from 'next/router'

import { getCategoryName } from 'components/nav/CategoriesMenu/utils/categories'
import { CategoriesModal } from 'components/partials/browse/CategoriesModal'
import { CategoriesSlider } from 'components/partials/browse/CategoriesSlider'
import { ButtonText } from 'components/ui/Buttons/Button'
import { Container } from 'styles/shared'
import { parseRouterQuery, parseRouterQueryAsNumber } from 'utils/parseRouterQuery'

type Props = {
  redirectTo: string
}

export const CategoriesCards: React.FC<Props> = ({ redirectTo }) => {
  const { t } = useTranslation('common')

  const [isCategoriesModalOpen, setIsCategoriesModalOpen] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState<number | undefined>(undefined)

  const router = useRouter()

  const handleSelectCategory = (category: ProductCategory) => {
    const categoryQueryName = parseRouterQuery(router.query.category) || ''
    // We want to clear search term on category change
    const searchTerm = ''
    const locationId = parseRouterQueryAsNumber(router.query.location) || ''
    const sortBy = parseRouterQuery(router.query.sortBy) || 'name'
    const sortDirection = parseRouterQuery(router.query.direction) || 'asc'

    const categoryLink = getCategoryName(category)
    const newCategoryQueryName = categoryLink === categoryQueryName ? '' : categoryLink
    setSelectedCategory(category.id)

    if (redirectTo) {
      router.push(
        `/${redirectTo}?searchTerm=${searchTerm}&location=${locationId}&category=${newCategoryQueryName}&sortBy=${sortBy}&direction=${sortDirection}`,
      )
    }
  }

  const toggleMobileMenu = () => {
    setIsCategoriesModalOpen((prevState) => !prevState)
    !isCategoriesModalOpen ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'auto')
  }

  return (
    <Box marginTop="20px" marginBottom="60px" display={{ base: 'block', md: 'none' }}>
      <Container>
        <Flex marginTop="36px" justifyContent="space-between" alignItems="center">
          <Text fontSize="sm">{t('categories')}</Text>
          <ButtonText onClick={toggleMobileMenu}>{t('showAll')}</ButtonText>
        </Flex>
        <CategoriesModal
          isOpen={isCategoriesModalOpen}
          handleSelectCategory={handleSelectCategory}
          onClose={toggleMobileMenu}
          selectedCategory={selectedCategory}
        />
      </Container>
      <CategoriesSlider handleSelectCategory={handleSelectCategory} selectedCategory={selectedCategory} />
    </Box>
  )
}
